"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _marqueeFunctions = require("./marquee-functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _base = require("@site/pattern-library-utils/base.functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _image = require("@site/pattern-library-core/image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TextBlockContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextBlockContainer",
  class: "pl-t1yi0cz7"
});
const Word = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Word",
  class: "pl-wix1asu"
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ImageWrapper",
  class: "pl-i1dpa5s1"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pl-iv5bk06"
});
function HighlightedTextBlock({
  textString,
  scrollProgress,
  inlineImage1,
  inlineImage2,
  inlineImage3
}) {
  const images = [inlineImage1, inlineImage2, inlineImage3];
  const parsedText = (0, _marqueeFunctions.parseText)(textString);
  const highlightableItems = (0, _react.useMemo)(() => parsedText.filter(item => item.type === 'word' || item.type === 'image'), [parsedText]);
  const totalItemCount = highlightableItems.length;
  const highlightIndex = Math.min(Math.ceil(scrollProgress * totalItemCount), totalItemCount);
  const renderedElements = [];
  let idx = -2;
  let imageIndex = 0;
  parsedText.forEach(item => {
    let isHighlighted = false;
    if (item.type === 'word' || item.type === 'image') {
      idx += 1;
      isHighlighted = idx < highlightIndex;
    }
    if (item.type === 'word') {
      renderedElements.push(/*#__PURE__*/_react.default.createElement(Word, {
        key: `word-${item?.text}-${idx}`,
        style: {
          opacity: isHighlighted ? 1 : 0.1
        },
        "aria-hidden": true
      }, item.text));
    } else if (item.type === 'image') {
      const currentImage = images[imageIndex] || {};
      renderedElements.push(/*#__PURE__*/_react.default.createElement(ImageWrapper, {
        key: `image-container-${idx}-${imageIndex}`
      }, /*#__PURE__*/_react.default.createElement(Image, {
        key: `img-${currentImage?.url}-${imageIndex}`,
        url: currentImage?.url,
        altText: currentImage?.altText,
        width: currentImage?.width,
        height: currentImage?.height,
        style: {
          opacity: isHighlighted ? 1 : 0.25
        },
        dataCy: `image-${imageIndex}`
      })));
      imageIndex += 1;
    } else if (item.type === 'break') {
      renderedElements.push(/*#__PURE__*/_react.default.createElement("br", {
        key: `br-${idx}`
      }));
    }
  });
  return /*#__PURE__*/_react.default.createElement(TextBlockContainer, {
    "data-cy": "text-block-container"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    className: "headline-string",
    text: renderedElements
  }));
}
var _default = exports.default = HighlightedTextBlock;
HighlightedTextBlock.propTypes = {
  textString: _propTypes.default.string,
  scrollProgress: _propTypes.default.number,
  image: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  inlineImage1: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  inlineImage2: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  inlineImage3: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  })
};